/* eslint-disable no-param-reassign */
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default
{
  getIcone: tipo => {
    if (tipo === 'success') {
      return 'SuccessCircleIcon'
    } if (tipo === 'alert') {
      return 'AlertCircleIcon'
    } if (tipo === 'danger') {
      return 'DangerCircleIcon'
    }
    return ''
  },

  install(Vue) {
    Vue.prototype.$erro = titulo => {
      Vue.prototype.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          icon: this.getIcone('danger'),
          variant: 'danger',
        },
      })
    }

    Vue.prototype.$aviso = titulo => {
      Vue.prototype.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          icon: this.getIcone('warning'),
          variant: 'warning',
        },
      })
    }

    Vue.prototype.$erroResponse = response => {
      const { data } = response
      let titulo = ''
      if (data.errors) {
        // eslint-disable-next-line prefer-destructuring
        titulo = data.errors[0]
      } else {
        titulo = data.message
      }
      Vue.prototype.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          icon: this.getIcone('danger'),
          variant: 'danger',
        },
      })
    }

    Vue.prototype.$sucesso = titulo => {
      Vue.prototype.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          icon: this.getIcone('success'),
          variant: 'success',
        },
      })
    }
  },
}
